import { useCallback, useState, useEffect,useRef, useContext } from 'react';
import { LayoutContext } from '_context/LayoutContext';
import { MapContext } from '_context/MapContext';

export function useToggle(initialValue = false) {
    const [toggle, setToggle] = useState(initialValue)
  
    return [toggle, useCallback(() => setToggle(status => !status), [])]
}



export function useLocalStorage(key, initialValue) {

  const [storedValue, setStoredValue] = useState(() => {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
  });

  const chkHistory = (arr,val) => {
    if(key==="GIS_RPList"){
      return arr.some(obj => obj.rp && obj.rp.start && obj.rp.end && val.rp.start.keyword === obj.rp.start.keyword && val.rp.end.keyword === obj.rp.end.keyword); 
    }else{
      return arr.some(obj => val.name === obj.name); 
    }
  }

  const setValue = value => {
    if(value==='allDelete'){
      window.localStorage.setItem(key, JSON.stringify([]));
      return
    }
    const valueToStore = storedValue;
    if(!chkHistory(valueToStore,value)){
      valueToStore.unshift(value);
      setStoredValue(valueToStore.slice(0,10));
      window.localStorage.setItem(key, JSON.stringify(valueToStore.slice(0,10)));
    }else{
      if(key==="GIS_RPList"){
        valueToStore.some((obj) => {
          if(obj.rp && obj.rp.start && obj.rp.end && value.rp.start.keyword === obj.rp.start.keyword && value.rp.end.keyword === obj.rp.end.keyword){
            obj.rp['wayPoints'] = value.rp['wayPoints']
            obj.rp['start'] = value.rp['start']
            obj.rp['end'] = value.rp['end']
            obj.timestamp = value.timestamp
            window.localStorage.setItem(key, JSON.stringify(valueToStore.slice(0,10)));
          }
        })
      }
    }
  };

  return [storedValue, setValue];
}



export function useWindowSize() {
  const isClient = typeof window === 'object';

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }
    
    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

export function useElemSize(elem) {

  const [elemSize, setElemSize] = useState(0);

  let movement_timer = null;
  const RESET_TIMEOUT = 100;

  useEffect(() => {
    if (!elem) {
      return false;
    }

     const chgElemHeight = () => {

      if (elem.current) {
        setElemSize(elem.current.clientHeight);
      }else{
       setElemSize(0);
      }
    };

    function handleSetResize() {
      clearInterval(movement_timer);
      movement_timer = setTimeout(chgElemHeight, RESET_TIMEOUT);
    }

    window.addEventListener('resize', handleSetResize);
    return () => window.removeEventListener('resize', handleSetResize);
  }, []);

  return elemSize;
}


export function useSaveObj(row) {

  const [obj, setObject] = useState({});

  const setObj = value => {
    setObject(value);
};

const getObj = ()=>{
  return obj;
}

  return [obj, setObj];
}


export function useSetRoute() {

  const { setRP } = useContext(MapContext);
  const { chgStatus, status } = useContext(LayoutContext);

  const setRoute = (target,keyword,point, mode="") => {

    let rp = {
      keyword : keyword,
      point
    }
    setRP(target,rp,mode);
    if(status!=="rp"){ chgStatus("rp"); }
  
  }
 
 
  return [setRoute];
}
